<template>
<div class="main-menu-wrapper" :class="{ active: isActive }">								
    <div class="menu-header">
        <router-link to="/home/" class="menu-logo">
            <img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo">
        </router-link>
        <a id="menu_close" class="menu-close" href="javascript:void(0);" @click="closeSidebar">
            <i class="fas fa-times"></i>
        </a>
    </div>

    <ul class="main-nav" :class="{ active: isActive }">
        <template v-for="item in HeaderData" :key="item.tittle">
           

<li class="has-mega-menu"
    v-if="item.tittle === 'About us'"
    @mouseenter="activeDropdown = 'about'"
    @mouseleave="activeDropdown = null">

  <a href="https://www.nextsense.nextsenseschool.edu.au/about/" class="nav-link"   :class="{ 'is-active': activeDropdown === 'about' }">
    About <br> NextSense
  </a>

  <!-- ▼ Dropdown -->
  <div class="mega-dropdown" v-if="activeDropdown === 'about'">

    <ul>

         <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/about/history/">
        Our History →
      </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/about/our-people/">
          Our People →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/about/governance/">
          Governance →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/about/careers/">
          Careers →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/about/feedback/">
          Feedback →
        </a>
      </li>
    </ul>
  </div>

</li>



            <li 
  v-if="item.tittle === 'cochlear-implant-services'" 
  @mouseenter="activeDropdown = 'cochlear'"
  @mouseleave="activeDropdown = null"
>
  <a 
    href="https://www.nextsense.nextsenseschool.edu.au/cochlear-implant-services/" 
    class="nav-link"
    :class="{ 'is-green-active': activeDropdown === 'cochlear' }"
  >
    Cochlear implant <br> services
  </a>
</li>




          <li 
  class="has-mega-menu"
  v-if="item.tittle === 'Services'"
  @mouseenter="activeDropdown = 'hearing'"
  @mouseleave="activeDropdown = null"
>

  <a 
    href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/" 
    class="nav-link"
    :class="{ 'is-pink-active': activeDropdown === 'hearing' }"
  >
    Hearing <br> services
  </a>

  <!-- ▼ Pink Dropdown -->
  <div class="mega-dropdown pink-dropdown" v-if="activeDropdown === 'hearing'">

    <ul>
      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/paediatric-audiology/">
          Paediatric audiology →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/allied-health-and-speech-therapy/">
          Allied health and <br> speech therapy →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/connected-services/">
          Connected services →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/early-intervention-hearing/">
          Early Intervention <br> hearing →
        </a>
      </li>
    </ul>

  </div>

</li>


<!-- ⭐ Vision Services Menu -->
<li 
  class="has-mega-menu"
  v-if="item.tittle === 'vision'"
  @mouseenter="activeDropdown = 'vision'"
  @mouseleave="activeDropdown = null"
>
  <a 
    href="https://www.nextsense.nextsenseschool.edu.au/vision-services/" 
    class="nav-link"
    :class="{ 'is-yellow-active': activeDropdown === 'vision' }"
  >
    Vision <br>services
  </a>

  <!-- ⭐ Dropdown -->
  <div class="mega-dropdown vision-dropdown" v-if="activeDropdown === 'vision'">
    <ul>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/vision-services/vision-assessments/">
          Vision assessments →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/vision-services/accessibility-and-inclusion/">
          Accessibility and <br> inclusion →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/allied-health-and-speech-therapy/">
          Allied health and <br> speech therapy →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/hearing-services/connected-services/">
          Connected services →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/vision-services/early-intervention-vision/">
          Early Intervention <br> vision →
        </a>
      </li>

    </ul>
  </div>
</li>


<!-- ⭐ School and Preschool -->
<li 
  class="has-mega-menu"
  v-if="item.tittle === 'news'"
  @mouseenter="activeDropdown = 'school'"
  @mouseleave="activeDropdown = null"
>
  <a 
    href="https://www.nextsenseschool.edu.au/" 
    class="nav-link"
    :class="{ 'is-green-active': activeDropdown === 'school' }"
  >
    School and <br>Preschool
  </a>

  <!-- ⭐ Green Dropdown -->
  <div class="mega-dropdown green-dropdown" v-if="activeDropdown === 'school'">
    <ul>
      <li>
        <a href="https://www.nextsenseschool.edu.au/">
          School →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/preschool-and-kindergarten/">
          Preschool and <br>Kindergarten →
        </a>
      </li>

      <li>
        <a href="https://www.nextsense.nextsenseschool.edu.au/professional-education/our-teachers/">
          Our Teachers →
        </a>
      </li>
    </ul>
  </div>
</li>


<li 
  v-if="item.tittle === 'news'"
  @mouseenter="activeDropdown = 'news'"
  @mouseleave="activeDropdown = null"
>
  <a 
    href="https://www.nextsense.nextsenseschool.edu.au/news-and-stories/" 
    class="nav-link"
    :class="{ 'is-pink-active': activeDropdown === 'news' }"
    style="font-family: var(--e-global-typography-text-font-family), Sans-serif;"
  >
    News and <br>stories
  </a>
</li>




            

            <li v-if="item.tittle === 'Courses'" :class="{ 'active': isActiveRoute(item.active_link) }">
  <!-- <router-link 
    :to="item.active_link"
    style="font-family: var(--e-global-typography-text-font-family), Sans-serif;"
  >
    Professional <br> education
  </router-link> -->

  <router-link 
  :to="item.active_link"
  class="nav-link pro-edu-link"
>
  Professional <br> education
</router-link>

</li>


    <!-- <template v-if="user">
  <li
    v-if="item.tittle === 'Dashboard'"
    :class="{ 'active': isActiveRoute(item.active_link) }"
  >
    <router-link
      :to="item.active_link"
      style="font-family: var(--e-global-typography-text-font-family), Sans-serif;"
    >
      {{ item.tittle }}
    </router-link>
  </li>
</template> -->


        </template>
    </ul>
    
    <div class="menu-dropdown">
        <div class="cart-item">
            <h6>Cart & Wishlist</h6>                                
            <div class="icon-btn">
                <router-link to="/courses/cart" class="position-relative">
                    <i class="isax isax-shopping-cart5"></i>
                    <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">1</span>
                </router-link>
            </div>
        </div>
        <div class="dropdown flag-dropdown mb-2">
            <a href="javascript:void(0);" class="dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                <img src="@/assets/img/flags/us-flag.svg" class="me-2" alt="flag">ENG
            </a>
            <ul class="dropdown-menu p-2 mt-2">
                <li>
                    <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                        <img src="@/assets/img/flags/us-flag.svg" class="me-2" alt="flag">ENG
                    </a>
                </li>
                <li>
                    <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                        <img src="@/assets/img/flags/arab-flag.svg" class="me-2" alt="flag">ARA
                    </a>
                </li>
                <li>
                    <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                        <img src="@/assets/img/flags/france-flag.svg" class="me-2" alt="flag">FRE
                    </a>
                </li>
            </ul>
        </div>
        <div class="dropdown mb-2">
            <a href="javascript:void(0);" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                USD
            </a>
            <ul class="dropdown-menu p-2 mt-2">
                <li><a class="dropdown-item rounded" href="javascript:void(0);">USD</a></li>
                <li><a class="dropdown-item rounded" href="javascript:void(0);">YEN</a></li>
                <li><a class="dropdown-item rounded" href="javascript:void(0);">EURO</a></li>
            </ul>
        </div>
        <div class="dropdown mb-2">
            <a href="javascript:void(0);" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                Light
            </a>
            <ul class="dropdown-menu p-2 mt-2">
                <li><a class="dropdown-item rounded" href="javascript:void(0);">Light</a></li>
                <li><a class="dropdown-item rounded" href="javascript:void(0);">Dark</a></li>
            </ul>
        </div>
    </div>

    
    <div class="menu-login">
        <router-link to="/login" class="btn btn-primary w-100 mb-2"><i class="isax isax-user me-2"></i>Sign In</router-link>
        <router-link to="/register" class="btn btn-secondary w-100"><i class="isax isax-user-edit me-2"></i>Register</router-link>
    </div>
</div>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
import HeaderData from '@/assets/json/header-menu.json'

export default {
    data() {
        return {
            HeaderData: HeaderData,
            route_array: [],
            openDropdownIndex: null,
            isDropdownOpen: false,
            isDropdownOpen1: null,
            isSidebarOpen: false,
            user:{},
            activeDropdown: null

        }
    },
     created(){
         const userData = localStorage.getItem("user");
         this.user = JSON.parse(userData)
        //  alert(this.user);
            if (userData) {
                this.user = JSON.parse(userData);
                // ✅ ab ye this.user me store hoga
                 console.log("Logged in user:", this.user);
            }
    },
    methods: {
        openSubMenu() {
            this.isDropdownOpen = !this.isDropdownOpen;
            this.openDropdownIndex = null;
        },
        openSubMenu1(index) {
            this.isDropdownOpen1 = this.isDropdownOpen1 === index ? null : index;
        },
        toggleSubMenu(index) {
            this.openDropdownIndex = this.openDropdownIndex === index ? null : index;
            this.isDropdownOpen = false;
        },
        closeSidebar() {
            this.isSidebarOpen = false;
            document.documentElement.classList.remove("menu-opened");
        },
        toggleTab(item) {
            item.showAsTab = !item.showAsTab;
        }
    },
    setup() {
        const route = useRoute();
        const isActive = ref(false);
    
        const activateMenu = () => {
            isActive.value = true;
        };
    
        const deactivateMenu = () => {
            isActive.value = false;
        };
    
        // Function to check if current route matches the active link
        const isActiveRoute = (activeLink) => {
            return route.path.includes(activeLink);
        };
    
        return {
            isActive,
            activateMenu,
            deactivateMenu,
            route,
            isActiveRoute
        };
    },
}
</script>

<style scoped>

    /* MENU SPACING FIX */


.main-nav .nav-link,
.mega-dropdown ul li a,
    .pink-dropdown ul li a,
    .green-dropdown ul li a,
    .vision-dropdown ul li a {
        font-family: var(--e-global-typography-text-font-family), Sans-serif !important;
    }


.has-mega-menu {
  position: relative;
}

.mega-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 146px;
  background: #000000;
  padding: 15px 20px;
  z-index: 999;
  border-radius: 0;
}

.mega-dropdown .dropdown-title {
  color: #00e1dc;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
}

.mega-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mega-dropdown ul li {
  padding: 8px 0;
  border-bottom: 1px solid #00e1dc;
}

.mega-dropdown ul li:last-child {
  border-bottom: none;
}

.mega-dropdown ul li a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
}

.mega-dropdown ul li a:hover {
  color: #00e1dc !important;
}


.nav-link.is-active {
  color: #00e1dc !important;  /* NextSense cyan */
}

.is-green-active {
  color: #5bf174 !important;     /* NextSense green */

}

/* Pink Active State */
.is-pink-active {
  color: #ff84b6 !important;  /* NextSense Pink */
  
}

/* Pink Dropdown styling */

.pink-dropdown {
  width: 205px !important;  
}


.pink-dropdown ul li {
  border-bottom: 1px solid #ff84b6 !important;
}

.pink-dropdown ul li:last-child {
  border-bottom: none !important;
}


.pink-dropdown ul li a {
  color: #ffffff !important;
}

.pink-dropdown ul li a:hover {
  color: #ff84b6 !important;
}


/* ⭐ Yellow Active State */
.is-yellow-active {
  color: #e5fb00 !important;      /* NextSense Yellow */
 
}

/* ⭐ Vision Dropdown Styling */
.vision-dropdown {
  width: 202px !important;
  background: #000 !important;   /* black background */
  border-radius: 0;
  padding: 20px;
  z-index: 999;
}

.vision-dropdown ul li {
  padding: 10px 0;
  border-bottom: 1px solid #e5fb00;    /* Yellow underline */
}

.vision-dropdown ul li:last-child {
  border-bottom: none;
}

.vision-dropdown ul li a {
  color: #ffffff !important;      /* Yellow text */
  font-size: 15px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vision-dropdown ul li a:hover {
  color: #e5fb00 !important;
}


/* ⭐ Green Active Tab */
.is-green-active {
  color: #5bf174 !important; 
  
}

/* ⭐ Green Dropdown */
.green-dropdown {
  width: 156px !important;              
  background: #000 !important;
  padding: 20px;
  z-index: 999;
  border-radius: 0;
}

.green-dropdown ul li {
  padding: 10px 0;
  border-bottom: 1px solid #5bf174;     /* green line */
}

.green-dropdown ul li:last-child {
  border-bottom: none;
}

.green-dropdown ul li a {
  color: #ffffff !important;            /* green text */
  font-size: 15px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.green-dropdown ul li a:hover {
  color: #5bf174 !important;
}


/* ⭐ Pink Active State for News & Stories */
.is-pink-active {
  color: #ff84b6 !important;        /* Pink text */
  
}

.pro-edu-link.nav-link.router-link-active,
.pro-edu-link.nav-link.router-link-exact-active {
  color: #00e1dc !important;  /* Same cyan as About */
}

.pro-edu-link:hover {
  color: #00e1dc !important;
}









</style>


